<template>
  <div class="studio-tabbar">
    <van-tabbar
      v-model="activeTabbar"
      inactive-color="#999999"
      active-color="#F5C682"
      @change="changeTabbarHandler"
    >
      <template v-for="item in tabbarItems">
        <van-tabbar-item
          v-if="item.show"
          :key="item.label"
          :name="item.name"
        >
          <span>{{ item.label }}</span>
          <template #icon="props">
            <img :src="props.active ? item.activeIcon : item.icon">
          </template>
        </van-tabbar-item>
      </template>
    </van-tabbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StudioTabbar',
  data: () => ({
    activeTabbar: ''
  }),
  computed: {
    ...mapGetters(['organization']),
    tabbarItems () {
      const { moduleOnlineLearn, moduleMall, moduleTools, moduleMine } = this.organization
      console.log({ moduleOnlineLearn, moduleMall, moduleTools, moduleMine })
      const init = [
        {
          label: moduleOnlineLearn.title || '在线学习',
          show: moduleOnlineLearn.enable,
          name: 'studio-teachers',
          icon: require(`@/assets/images/tabbar/studio/a.png`),
          activeIcon: require(`@/assets/images/tabbar/studio/active-a.png`)
        },
        {
          label: moduleTools.title || '工具',
          show: moduleTools.enable,
          name: 'studio-tools',
          icon: require(`@/assets/images/tabbar/studio/d.png`),
          activeIcon: require(`@/assets/images/tabbar/studio/active-d.png`)
        },
        {
          label: moduleMall.title || '商城',
          show: moduleMall.enable,
          name: 'studio-commodities',
          icon: require(`@/assets/images/tabbar/studio/b.png`),
          activeIcon: require(`@/assets/images/tabbar/studio/active-b.png`)
        },
        {
          label: moduleMine.title || '我的',
          show: moduleMine.enable,
          name: 'studio-user',
          icon: require(`@/assets/images/tabbar/studio/c.png`),
          activeIcon: require(`@/assets/images/tabbar/studio/active-c.png`)
        }
      ]
      return init
    }
  },
  watch: {
    '$route.name' (activeName) {
      console.log('活动的 StudioTabbar', activeName)
      this.toggoleTabbar(activeName)
    }
  },
  async created () {
    const { name } = this.$route
    this.toggoleTabbar(name)
  },
  methods: {
    toggoleTabbar (activeName) {
      const navigations = {
        'studio-teachers': ['studio-teachers', 'teacher-home', 'teacher-courses', 'teacher-videos', 'teacher-creations'],
        'studio-user': ['studio-user'],
        'studio-tools': ['studio-tools'],
        'studio-commodities': ['studio-commodities']
      }
      for (const key in navigations) {
        if (navigations[key].includes(activeName)) {
          this.activeTabbar = key
          break
        }
      }
    },
    changeTabbarHandler (activeName) {
      this.$router.push({ name: activeName })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
